<template>
  <div class='wrapper'>
    <div v-if='request.state.pending' v-loading></div>
    <template v-else-if='user'>
      <header-block />

      <router-view v-slot='{ Component, route }'>
        <transition name='fade' mode='out-in'>
          <main class='content' :key='route.path'>
            <component :is='Component' />
          </main>
        </transition>
      </router-view>

      <footer class='footer'></footer>
    </template>
    <login-page v-else />
  </div>
</template>

<script setup lang='ts'>
import LoginPage from '@/pages/LoginPage.vue'
import store from '@/store'
import { computed } from 'vue'
import useFormRequest from '@/composables/useFormRequest'
import { loadUser } from '@/api/auth'
import HeaderBlock from '@/components/HeaderBlock.vue'
import { loadRegions } from './api/regions'

const user = computed(() => store.state.user)

const token = (new Map<string, string>(
  document.cookie.split(';').map(cookie => cookie.split('=').map(v => v.trim()) as [string, string])
)).get('cToken')

const request = useFormRequest()

if (token) {
  request.tryRequest(async () => {
    const response = await loadUser(token)
    store.login(response.data)

    const regionsResponse = await loadRegions()
    store.setRegions(regionsResponse.data)
  })
}
</script>
